module.exports = {"410304001":"东关街道","410304002":"瀍西街道","410304003":"五股路街道","410304004":"北窑街道","410304005":"塔湾街道","410304006":"杨文街道","410304007":"华林街道","410304200":"瀍河回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410304.json
// module id = 1540
// module chunks = 0